import React, { useEffect, useRef, useState } from 'react';
import { createOpenerBridge } from '../utils/shopifyLinkHandshake';

/** Embedded-shell entry: opens the CI link page and vends fresh Shopify tokens to it, bound by origin+source. */
export default function ShopifyLinkEntry({ openWindow = (u, n) => window.open(u, n), getIdToken = () => window.shopify.idToken(), origin = window.location.origin }) {
  const child = useRef(null); const bridge = useRef(null); const [blocked, setBlocked] = useState(false);
  useEffect(() => {
    const onMsg = (ev) => { if (bridge.current) bridge.current.handleMessage(ev); };
    window.addEventListener('message', onMsg);
    return () => window.removeEventListener('message', onMsg);
  }, []);
  const open = () => {
    bridge.current = createOpenerBridge({ origin, getChild: () => child.current, getIdToken });
    const w = openWindow(`${origin}/shopify-link?link_popup=1`, 'ci-shopify-link'); /* link_popup=1: keeps the popup origin-direct (see public/link-popup-guard.js); opener/origin/source/nonce handshake unchanged */   // no noopener: the opener link is the protocol's binding
    child.current = w || null; setBlocked(!w);
  };
  return (
    <section className="p-4 mb-4 bg-white border border-slate-200 rounded" data-testid="shopify-link-entry">
      <h2 className="font-semibold mb-1">Commerce Index account</h2>
      <p className="text-sm text-slate-600 mb-2">Link this store to your Commerce Index account. You will sign in to Commerce Index in a new window.</p>
      <button type="button" onClick={open} className="px-3 py-2 bg-slate-900 text-white rounded">Link to Commerce Index account</button>
      {blocked && <p role="alert" className="text-sm mt-2">Your browser blocked the new window. Allow pop-ups for this app and try again.</p>}
    </section>
  );
}
